<i18n
  src="@/locales/views/producer/projections/estimated_harvest/show_harvest_process.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/estimated_container.yml" lang="yaml"></i18n>
<template>
  <div class="mt-6">
    <h1 class="page-title">
      <i class="fa-solid fa-container-storage"></i
      ><span class="space-icon"></span
      >{{ $t("labels.estimated_containers_title") }}
    </h1>
    <div class="mt-8 flex flex-col">
      <ag-grid-vue
        v-if="estimated_containers.length > 0"
        style="width: 100%; height: 600px"
        class="ag-theme-alpine w-full h-full"
        @grid-ready="onGridReady"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="estimated_containers_modified"
      ></ag-grid-vue>
    </div>
  </div>
</template>

<script>
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue3";

export default {
  name: "ShowHarvestProcessEstimatedContainers",
  components: { AgGridVue },
  data() {
    return {
      defaultColDef: {
        sortable: true,
        filter: true,
        floatingFilter: true
      },
      columnDefs: [
        {
          headerName: this.$t("model.estimated_container.week"),
          field: "week",
          filter: "agNumberColumnFilter"
        },
        {
          headerName: this.$t("model.estimated_container.num_containers"),
          field: "num_containers",
          filter: "agNumberColumnFilter",
          cellRenderer: params => {
            return this.numberWithPrecision(params.value, 1);
          }
        },
        ...this.harvest_process_crop_size_groups.map(
          harvest_process_crop_size_group => {
            return {
              headerName: harvest_process_crop_size_group.name + " (%)",
              field: `${harvest_process_crop_size_group.id}`,
              filter: "agNumberColumnFilter"
            };
          }
        )
      ]
    };
  },
  props: {
    estimated_containers: {
      type: Array,
      required: true
    },
    harvest_process_crop_size_groups: {
      type: Array,
      required: true
    }
  },
  computed: {
    estimated_containers_modified: function () {
      return this.estimated_containers.map(estimated_container => {
        let estimated_container_groups = {};
        this.harvest_process_crop_size_groups.forEach(
          harvest_process_crop_size_group => {
            estimated_container_groups[harvest_process_crop_size_group.id] =
              estimated_container.estimated_container_groups.find(
                ecg =>
                  ecg.harvest_process_crop_size_group_id ==
                  harvest_process_crop_size_group.id
              )?.percent || "";
          }
        );
        return {
          ...estimated_container,
          ...estimated_container_groups
        };
      });
    }
  },
  methods: {
    sizeToFit() {
      this.gridApi.sizeColumnsToFit({
        defaultMinWidth: 150
      });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.sizeToFit();
    }
  }
};
</script>
